import { EColors, EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
    className?: string;
}

export const MinutePageTitle = (props: Props): JSX.Element => {
    return (
        <S_MinutePageTitle className={props.className}>
            <S_Title>{props.title}</S_Title>
            {(props.subtitle || props.children) && (
                <S_P>
                    {props.subtitle} {props.children}
                </S_P>
            )}
        </S_MinutePageTitle>
    );
};

const S_MinutePageTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 15px;
    @media only screen and (min-width: 1260px) {
        padding: 0;
    }
`;

const S_Title = styled.div`
    margin: 40px 0px 20px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Bold};
    font-size: 42px;
    line-height: 50px;
    letter-spacing: -0.03em;
    padding: 0 20px;
`;

const S_P = styled.div`
    margin: 0px 0px 40px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Medium};
    font-size: 16px;
    line-height: 27px;
    padding: 0 20px;
    text-align: center;
    a {
        text-decoration: underline;
        color: ${EColors.DARK};
        font-family: ${EFonts.Medium};
        &:hover {
            text-decoration: none;
        }
    }
`;
